export default "__VITE_ASSET__dsrpZX2Q__"